import styled, { css } from 'styled-components';

import {
    floorGameColor as color,
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledSkeleton,
    styledTypography,
} from '@pkg/primitives';

import { tokens } from '../../DataTable.tokens';
import { type DataTableValueVariant } from '../../DataTable.types';

interface StyledDataValueProps {
    $variant?: DataTableValueVariant;
}

const typographyBase = css`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.dataValue.fontSize}px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.02em;
`;

export const StyledDataValue = styled.div<StyledDataValueProps>`
    --suffix-color: rgb(255, 255, 255, 0.5);

    display: grid;
    grid-auto-flow: column;
    justify-content: var(--data-table-last-cell-align, start);
    align-content: center;
    gap: ${tokens.dataValue.gap}px;

    ${({ $variant }) => {
        if ($variant === 'positive') {
            return css`
                --suffix-color: ${color.green};
            `;
        }

        if ($variant === 'negative') {
            return css`
                --suffix-color: ${color.red};
            `;
        }
    }};
`;

export const Value = styled.p`
    ${typographyBase};
`;

export const Suffix = styled.p`
    ${typographyBase};
    color: var(--suffix-color);
    transition: color ${duration.normal}ms ${easing.cubic};
`;

export const EmptyState = styled.p`
    ${typographyBase};
`;

export const Skeleton = styled.div`
    ${styledSkeleton.baseStyles};
    width: 100%;
    min-width: ${tokens.dataValue.fontSize * 3}px;
    height: ${tokens.dataValue.fontSize - tokens.skeleton.heightOffset}px;
    border-radius: 999px;
`;
